module.exports = __webpack_public_path__ + "static/media/404.42945b02.png";